import React from 'react'
import { categories } from '../data/data'
const Category = () => {
  return (
    <div className="max-w-[1640px] m-auto px-4 py-12">
        <h1 className="font-bold text-orange-600 text-4xl text-center">Top Rated Menu Items</h1>
        <div className="grid grid-cols-2 md:grid-cols-4 py-6 gap-6">
        {categories.map((item, index) => (
                <div key={index} className="bg-gray-100 rounded-lg p-4 flex items-center justify-between">
                <h1 className="font-bold">{item.name}</h1>
                <img src={item.image} alt={item.name} className="w-20"/>
                </div>
        ))}
        </div>

    </div>
  )
}

export default Category